import { cnCard } from '@/blocks/card'
import style from './card__line.module.sass'
import { styled } from '@/utils/block'

styled(style)

export function CardLine(): JSX.Element {
  return <div className={cnCard('line')} />
}
